// extracted by mini-css-extract-plugin
module.exports = {"building-blocks":"acf-building-blocks_building-blocks__aaAp4"};